(() => {
  'use strict';

  const CLASS_ACTIVE = 'is-active';
  const breakpoints = {
    sp: 768,
    pc: 769,
  };

  function scrollFadeIn() {
    const element = document.querySelectorAll('.js-fadeIn');
    const pos = window.innerHeight * 0.8;

    element.forEach((el) => {
      let rect = el.getBoundingClientRect().top;

      if (pos > rect) {
        el.classList.add(CLASS_ACTIVE);
      }
    });
  }
  window.addEventListener('scroll', scrollFadeIn);
})();
